<template>
  <FormButtonGroup align="end" spaced>
    <FormButton
      text="Selecionar todos"
      type="primario"
      outlined
      beforeIcon="fas fa-check-double"
      :disabled="disabled"
      :loading="loadingSelectAll"
      @click="$emit('select-all')"
    />
    <FormButton
      text="Desmarcar"
      type="auxiliar"
      outlined
      beforeIcon="fas fa-times-circle"
      :disabled="disabled"
      @click="$emit('clear-all')"
    />
  </FormButtonGroup>
</template>

<script>
import FormButton from "@/components/form/FormButton";
import FormButtonGroup from "@/components/form/FormButtonGroup";

export default {
  name: "PerfisBulkSelectActions",
  components: { FormButton, FormButtonGroup },
  props: {
    disabled: { type: Boolean, default: false },
    loadingSelectAll: { type: Boolean, default: false }
  }
};
</script>
